import type { BrandConfig } from "@/types/branding";

/**
 * Applies brand CSS custom properties to document.documentElement.
 * Used at runtime when brand config is loaded (replaces static per-brand CSS blocks).
 */
export function applyBrandStyles(config: BrandConfig): void {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  const { colors } = config;

  root.style.setProperty("--gail-color-primary", colors.primary);
  root.style.setProperty("--gail-color-secondary", colors.secondary);
  root.style.setProperty("--gail-color-tertiary", colors.tertiary);
  root.style.setProperty("--gail-text-color", colors.textColor);
  root.style.setProperty("--btn-primary-text-color", colors.btnPrimaryText);
  root.style.setProperty("--btn-secondary-text-color", colors.btnSecondaryText);
  root.style.setProperty("--btn-tertiary-text-color", colors.btnTertiaryText);
  root.style.setProperty("--gail-brand-primary", colors.primary);
  root.style.setProperty(
    "--brand-logo-url",
    `url("${config.logoUrl}")`
  );

  if (colors.primaryComplement) {
    root.style.setProperty("--gail-color-primary-complement", colors.primaryComplement);
  } else {
    root.style.removeProperty("--gail-color-primary-complement");
  }
  if (colors.secondaryComplement) {
    root.style.setProperty("--gail-color-secondary-complement", colors.secondaryComplement);
  } else {
    root.style.removeProperty("--gail-color-secondary-complement");
  }
}
